export default "__VITE_ASSET__Bmpoettk__"